var THEME_ID = '$$material';

export { THEME_ID as default };
